import FourOFourComponent from "../MVPComponents/FourOFour";

const FourOFour = () => {
  return (
    <div>
      <FourOFourComponent />
    </div>
  );
};

export default FourOFour;
